import React from 'react';

function Home() {
  return (
    <div className="home-content">
      <h4>
        WELCOME TO MATH MAGICIAN
      </h4>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Accusantium maximenobis similique nisi voluptatum, numquam
        perferendis deserunt fuga obcaecati iure,eius omnis aperiam
        quis. Officia voluptatum maiores soluta eveniet rem. Lorem,
        ipsum dolor

      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipisicing elit.
        Accusantium maximenobis similique nisi voluptatum, numquam
        perferendis deserunt fuga obcaecati iure,eius omnis aperiam
        quis. Officia voluptatum maiores soluta eveniet rem. Lorem,
        ipsum dolor

      </p>
    </div>
  );
}

export default Home;
